// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"300":"8a0a0932","748":"1f10edd7"}[chunkId] + ".js";
};